import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Select} from '../../system/select';
import React, {useEffect, useState} from 'react';
import {usePulsoidClient} from '../../PulsoidClient';
import Form from 'react-bootstrap/Form';
import {ActionWithProgress} from '../../system/buttons';

export const AutomatedClips = ({profile}) => {
  let client = usePulsoidClient();
  let [status, setStatus] = useState();
  let [thresholdBpm, setThresholdBpm] = useState();
  let [updated, setUpdated] = useState(false);
  let [thresholdBpmError, setThresholdBpmError] = useState(false);
  let isTwitchConnected = profile && profile.isTwitchConnected;

  let fetchData = async () => {
    let {settings} = await client.getAutomatedClipsSettings();
    setStatus(settings.status);
    setThresholdBpm(settings.thresholdBpm);
    setUpdated(false);
  };

  useEffect(fetchData, []);

  if (!status) {
    return '';
  }

  return (
    <>
      <h4>Automated clips</h4>
      <hr />
      <Row className={'p-2'}>
        <Col sm={2}>Status</Col>
        <Col sm={3}>
          <Select
            value={status}
            onChange={(e) => {
              if (e === 'Custom' && e !== status) {
                setThresholdBpm(110);
              }
              setStatus(e);
              setUpdated(true);
            }}
          >
            <option value={'Off'}>Off</option>
            <option value={'Custom'}>On</option>
          </Select>
        </Col>
      </Row>
      {status === 'Custom' && (
        <Row className={'p-2'}>
          <Col sm={2}>Trigger bpm</Col>
          <Col sm={3}>
            <Form.Control
              type="number"
              value={thresholdBpm}
              isInvalid={thresholdBpmError}
              onChange={(e) => {
                setThresholdBpmError(false);
                setThresholdBpm(parseInt(e.target.value));
                setUpdated(true);
              }}
            />
          </Col>
        </Row>
      )}
      <Row className={'p-2 pl-5'}>
        <Col>
          {updated && !isTwitchConnected && (
            <div>
              Connect Twitch account above before setting up automated clips
              feature.
            </div>
          )}
          {updated && (
            <ActionWithProgress
              disabled={!isTwitchConnected}
              onClick={async () => {
                if (status === 'Custom' && isNaN(thresholdBpm)) {
                  setThresholdBpmError(true);
                } else {
                  await client.updateAutomatedClipSettings(
                    status,
                    thresholdBpm
                  );
                  await fetchData();
                }
              }}
            >
              Update
            </ActionWithProgress>
          )}
        </Col>
      </Row>
    </>
  );
};
